import { IWorkspaceResourceFolder, WorkspaceResourceFolderType } from "common/interfaces";

function shouldCoerceFolderTypeToShared(folderType: WorkspaceResourceFolderType) {
    return folderType === WorkspaceResourceFolderType.PERSONAL;
}

/**
 * Temporary: new library UI treats personal folders as shared.
 * Remove after migrate-personal-folders-to-shared completes.
 */
export function coercePersonalFolderTypeToShared<T extends IWorkspaceResourceFolder | null | undefined>(folder: T): T {
    if (!folder || !shouldCoerceFolderTypeToShared(folder.folderType)) {
        return folder;
    }
    return { ...folder, folderType: WorkspaceResourceFolderType.SHARED };
}

export function coercePersonalFoldersTypeToShared(folders: IWorkspaceResourceFolder[]): IWorkspaceResourceFolder[] {
    return folders.map(folder => coercePersonalFolderTypeToShared(folder));
}

export function hasFolderTypeToCoerceToShared(folders: IWorkspaceResourceFolder[] | null | undefined) {
    return !!folders?.some(folder => shouldCoerceFolderTypeToShared(folder.folderType));
}
